export var UNICODE_CHARS = {
    equal: '\u003D',
    notEqual: '\u2260',
    lessThan: '\u003C',
    lessThanOrEqual: '\u2264',
    greaterThan: '\u003E',
    greaterThanOrEqual: '\u2265',
    noBreakSpace: '\u00A0',
};
